import React from 'react';
import {Promotions} from 'api';
import {UploadImage} from 'components/UI/Image';

class HighlightPromotions extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: [],
      limit: 3
    };
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: 'createdAt DESC'
      }
    };
    Promotions.actions.all.request(params).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  render() {
    return (
      <div className="center banner-demand">
        <h2 className="highlight-title"><span className="black-title">SẢN PHẨM OCOP</span></h2>
        <div className='banner-demand-row'>
          {
            this.state.data.map((item, index) => {
              return(
                <div className='wrap-abnner-demand'>
                  <a className='item-link' href={item.link} target="_blank">
                    <UploadImage transform="crop" type="PROMOTION" width="545" className='image' height="300" image={item.image}/>
                  </a>
                </div>
              )
            })
          }
        </div>
      </div>
    );
  }
}

export default HighlightPromotions;



// WEBPACK FOOTER //
// ./components/home/sub-view/HighlightPromotions.jsx